/* CorkProTech · ficha de producto.
   Porta la lógica del tema actual sin Borders: variantes (sin renombrar nada: el ERP empareja por
   variante), galería por variante (custom.galeria_*), entrega por país, barra fija y compra.
   Un solo JSON por ficha (snippets/pdp-data.liquid). */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const money = (cents) => window.CorkMoney(cents);
  const displayValue = (value) => String(value).replace(/Iphone/g, 'iPhone');
  const searchable = (text) => String(text).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '');

  class Product {
    constructor(root) {
      this.root = root;
      this.data = JSON.parse(root.querySelector('[data-product-json]').textContent);
      this.variants = this.data.variants;
      /* En una funda, la 1.ª opción es el modelo y la 2.ª, si la hay, el diseño (como main-product.liquid):
         por posición, porque en los otros idiomas el nombre llega traducido («Design…»). */
      this.modelIndex = 0;
      this.designIndex = this.data.isCase && this.data.options.length > 1 ? 1 : -1;
      this.form = root.querySelector('[data-product-form]');
      this.idInput = root.querySelector('[data-variant-input]');
      this.addButton = root.querySelector('[data-add-button]');
      this.qtyInput = root.querySelector('[data-qty-input]');
      this.validators = [];
      this.variant = this.variants.find((v) => String(v.id) === this.idInput?.value) || this.variants[0];

      this.gallery = new Gallery(root, this.data);
      this.delivery = new Delivery(root.querySelector('[data-delivery]'), this);
      this.sticky = new StickyBuy(root, this);
      this.cordActive = false;

      root.addEventListener('change', (event) => {
        const control = event.target.closest('[data-option]');
        if (control) this.onOption(Number(control.dataset.option), control.value);
      });
      this.setupQuantity();
      this.setupCordPicker();
      this.form?.addEventListener('submit', (event) => this.onSubmit(event));
      this.setupPayLater();
      this.setupMoreOptions();
      this.setupTech();
      this.picker = new ModelPicker(this);

      this.units = new Units(this);
      this.bundle = new Bundle(this);
      this.addon = new Addon(this);
      this.gallery.show(this.variant);
      this.delivery.render();
      this.renderVariantText();
      root.product = this;
    }

    /* Opciones: combinación exacta o, si no existe, la más parecida que conserve la opción tocada. */
    onOption(changed, value) {
      const selected = [...this.variant.o];
      selected[changed] = value;
      let next = this.variants.find((v) => v.o.every((value, i) => value === selected[i]));
      if (!next) {
        const score = (v) => v.a * 10 + v.o.filter((value, i) => i !== changed && value === selected[i]).length;
        next = this.variants.filter((v) => v.o[changed] === selected[changed]).sort((a, b) => score(b) - score(a))[0];
      }
      if (next) this.setVariant(next);
    }

    /* Un modelo que no tiene Slim (snippets/extreme-models): la compra deja su sitio al botón «Extreme», que lleva
       a la Extreme con ese modelo. Al volver a un modelo de la Slim, setVariant lo deshace. */
    showExtreme(value, url) {
      const next = this.root.querySelector('[data-extreme-next]');
      if (!url || !next) return;
      this.root.dataset.extreme = '';
      next.querySelector('a').href = url;
      next.hidden = false;
      this.picker.root.querySelector('[data-picker-current]').textContent = displayValue(value);
      this.picker.root.querySelectorAll('[data-picker-pick]').forEach((chip) => chip.setAttribute('aria-pressed', 'false'));
      this.sticky.update?.();
    }

    setVariant(variant) {
      if ('extreme' in this.root.dataset) {
        delete this.root.dataset.extreme;
        this.root.querySelector('[data-extreme-next]').hidden = true;
        this.sticky.update?.();
      }
      const previous = this.variant;
      this.variant = variant;
      if (this.idInput) this.idInput.value = variant.id;
      this.syncControls();
      this.renderTitle();
      this.renderSummary();
      this.renderOfferThumbs();
      this.renderSpecs();
      this.renderTech();
      this.renderPrice();
      this.renderButton();
      this.renderDesigns();
      this.renderVariantText();
      if (variant.f !== previous.f) this.gallery.show(variant);
      this.delivery.render();
      this.sticky.render();
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState(window.history.state, '', url.toString());
      this.root.dispatchEvent(new CustomEvent('product:variant', { bubbles: true, detail: { variant } }));
    }

    syncControls() {
      this.root.querySelectorAll('[data-option]').forEach((control) => {
        const value = this.variant.o[Number(control.dataset.option)];
        if (control.tagName === 'SELECT') control.value = value;
        else control.checked = control.value === value;
      });
      this.root.querySelectorAll('[data-option-current]').forEach((label) => {
        label.textContent = displayValue(this.variant.o[Number(label.dataset.optionCurrent)]);
      });
    }

    renderTitle() {
      /* Titular para todos los modelos (Slim y Extreme sin ?variant=): al elegir un modelo pasa al de siempre,
         «[entrada] [modelo] · [línea]», como el que sirve Shopify con ?variant=. */
      const generic = this.root.querySelector('[data-title-generic]');
      if (generic) {
        const model = document.createElement('span');
        model.dataset.titleModel = '';
        const line = document.createElement('span');
        line.className = 'pdp__line';
        line.textContent = generic.dataset.line;
        generic.replaceChildren(`${generic.dataset.lead} `, model, ' ', line);
        generic.removeAttribute('data-title-generic');
      }
      const model = this.root.querySelector('[data-title-model]');
      if (model) model.textContent = displayValue(this.variant.o[this.modelIndex]);
    }

    /* Resumen «Tu funda»: línea, opciones y precio de la funda elegida (la foto, la de su variante). */
    renderSummary() {
      const box = this.root.querySelector('[data-summary]');
      if (!box) return;
      box.querySelector('[data-summary-options]').textContent = this.variant.o.map(displayValue).join(' · ');
      box.querySelector('[data-summary-price]').textContent = money(this.variant.p);
      const media = this.gallery.media?.find((m) => String(m.id) === String(this.variant.f));
      const img = box.querySelector('[data-summary-img] img');
      if (media && img) {
        img.removeAttribute('srcset');
        img.src = this.gallery.src(media, 160);
      }
    }

    /* Tarjeta de la 2ª unidad: delante, la funda elegida; detrás, el mismo modelo con otro diseño (sin
       diseños, la misma funda). Solo cambia las fotos: la oferta y su cálculo no se tocan. */
    renderOfferThumbs() {
      const imgs = this.root.querySelectorAll('[data-offer-thumbs] img');
      if (imgs.length < 2) return;
      const model = this.variant.o[this.modelIndex];
      const other = this.designIndex > -1 && this.variants.find((v) => v.f && v.o[this.modelIndex] === model && v.o[this.designIndex] !== this.variant.o[this.designIndex]);
      [other || this.variant, this.variant].forEach((variant, i) => {
        const media = this.gallery.media?.find((m) => String(m.id) === String(variant.f));
        if (!media) return;
        imgs[i].removeAttribute('srcset');
        imgs[i].src = this.gallery.src(media, 120);
      });
    }

    /* Especificaciones: modelo y texto de la variante (medidas y peso), antes de las filas fijas. */
    renderSpecs() {
      const list = this.root.querySelector('[data-specs]');
      if (!list) return;
      list.querySelectorAll('[data-spec-dyn]').forEach((row) => row.remove());
      const rows = [[this.data.options[this.modelIndex], displayValue(this.variant.o[this.modelIndex])]];
      String(this.variant.t || '').split('\n').forEach((line) => {
        const at = line.indexOf(':');
        if (at > 0 && line.slice(at + 1).trim()) rows.push([line.slice(0, at).trim(), line.slice(at + 1).trim()]);
      });
      list.prepend(...rows.map(([label, value], i) => {
        const row = document.createElement('div');
        row.className = 'specs-row';
        row.dataset.specDyn = '';
        const dt = document.createElement('dt');
        dt.textContent = label;
        const dd = document.createElement('dd');
        dd.textContent = value;
        if (i > 0) dd.className = 'tabular';
        row.append(dt, dd);
        return row;
      }));
    }

    /* Vista técnica de la galería: dibujo a escala con cotas (alto, ancho, grosor y peso) sacadas
       del texto de la variante. Sin medidas, no hay botón. */
    setupTech() {
      this.techToggle = this.root.querySelector('[data-tech-toggle]');
      this.techView = this.root.querySelector('[data-tech-view]');
      if (!this.techToggle) return;
      this.techToggle.addEventListener('click', () => {
        const on = this.techToggle.getAttribute('aria-pressed') !== 'true';
        this.techToggle.setAttribute('aria-pressed', String(on));
        this.techView.hidden = !on;
      });
      this.renderTech();
    }

    renderTech() {
      if (!this.techToggle) return;
      const lines = String(this.variant.t || '').split('\n');
      const sizeLine = lines.find((line) => /\d\s*[×x]\s*\d/.test(line));
      const weightLine = lines.find((line) => /\d\s*g\b/.test(line));
      const dims = sizeLine ? (sizeLine.match(/\d+(?:[.,]\d+)?/g) || []) : [];
      if (dims.length < 2) {
        this.techToggle.hidden = true;
        this.techView.hidden = true;
        this.techToggle.setAttribute('aria-pressed', 'false');
        return;
      }
      const label = sizeLine.split(':')[0].trim();
      const weight = weightLine ? weightLine.split(':').pop().trim() : '';
      const [h, w, d] = dims.map((n) => Number.parseFloat(n.replace(',', '.')));
      this.techToggle.hidden = false;
      this.techToggle.querySelector('[data-tech-label]').textContent = label;
      const H = 250;
      const W = H * (w / h);
      const x = 200 - W / 2;
      const y = 200 - H / 2 - 10;
      const r = W * 0.16;
      const cam = W * 0.42;
      const mm = (n) => `${String(n).replace('.', ',')} MM`;
      const tick = (x1, y1, x2, y2) => `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}"/>`;
      this.techView.innerHTML = `<svg viewBox="0 0 400 400" role="img" aria-label="${label}: ${sizeLine.split(':').pop().trim()}${weight ? `, ${weight}` : ''}">
        <g class="tech__ext">${tick(x - 44, y, x - 6, y)}${tick(x - 44, y + H, x - 6, y + H)}${tick(x, y + H + 6, x, y + H + 44)}${tick(x + W, y + H + 6, x + W, y + H + 44)}</g>
        <rect class="tech__case" x="${x}" y="${y}" width="${W}" height="${H}" rx="${r}"/>
        <rect class="tech__cam" x="${x + W * 0.09}" y="${y + W * 0.09}" width="${cam}" height="${cam}" rx="${cam * 0.28}"/>
        <g class="tech__dim">${tick(x - 32, y, x - 32, y + H)}${tick(x - 38, y, x - 26, y)}${tick(x - 38, y + H, x - 26, y + H)}${tick(x, y + H + 32, x + W, y + H + 32)}${tick(x, y + H + 26, x, y + H + 38)}${tick(x + W, y + H + 26, x + W, y + H + 38)}</g>
        <text class="tech__label" x="${x - 42}" y="${y + H / 2}" transform="rotate(-90 ${x - 42} ${y + H / 2})" text-anchor="middle">${mm(h)}</text>
        <text class="tech__label" x="${x + W / 2}" y="${y + H + 56}" text-anchor="middle">${mm(w)}</text>
        ${d ? `<text class="tech__label" x="${x + W + 18}" y="${y + 14}">${mm(d)}</text>` : ''}
        ${weight ? `<text class="tech__label" x="${x + W + 18}" y="${y + 34}">${weight.toUpperCase()}</text>` : ''}
      </svg>`;
    }

    renderPrice() {
      const box = this.root.querySelector('[data-price]');
      if (!box) return;
      const v = this.variant;
      const onSale = v.c > v.p;
      box.querySelector('[data-price-amount]').textContent = money(v.p);
      const compare = box.querySelector('[data-price-compare]');
      const save = box.querySelector('[data-price-save]');
      compare.hidden = !onSale;
      save.hidden = !onSale;
      if (onSale) {
        compare.textContent = money(v.c);
        save.textContent = save.dataset.template.replace('[amount]', money(v.c - v.p));
      }
    }

    renderButton() {
      const button = this.addButton;
      if (!button || button.getAttribute('aria-busy') === 'true') return;
      const available = Boolean(this.variant.a);
      button.disabled = !available;
      button.querySelector('[data-add-label]').textContent = available ? button.dataset.labelAdd : button.dataset.labelSoldout;
      const total = this.total();
      button.querySelector('[data-add-price]').textContent = available && total !== null ? `· ${money(total)}` : '';
    }

    /* Total del botón: fundas (con el descuento de Shopify si hay varias) más el complemento marcado.
       null si el de las fundas aún no está calculado. */
    total() {
      const cases = this.unitsTotal ? this.unitsTotal() : this.variant.p;
      return cases === null ? null : cases + (this.addonTotal ? this.addonTotal() : 0);
    }

    /* Sobreprecio de cada diseño para el modelo elegido. Un diseño que no existe para ese modelo (hay
       modelos solo en Classic) no se enseña ni se puede elegir; uno agotado se ve atenuado. */
    renderDesigns() {
      const box = this.root.querySelector('[data-designs]');
      if (!box || this.designIndex < 0) return;
      const d = this.designIndex;
      const m = d === 0 ? 1 : 0;
      const model = this.variant.o[m];
      const sameModel = this.variants.filter((v) => v.o[m] === model);
      const classic = sameModel.find((v) => v.o[d].toLowerCase() === 'classic') || this.variant;
      box.querySelectorAll('.design').forEach((tile) => {
        const input = tile.querySelector('input');
        const match = sameModel.find((v) => v.o[d] === input.value);
        const delta = match ? match.p - classic.p : 0;
        tile.querySelector('[data-design-delta]').textContent = delta > 0 ? `+${money(delta)}` : box.dataset.originalLabel;
        tile.hidden = !match;
        input.disabled = !match;
        tile.toggleAttribute('data-unavailable', Boolean(match) && !match.a);
      });
      /* Modelos solo en Classic: su nota, y la oferta de la 2ª unidad sin «diseño de regalo». */
      const onlyClassic = sameModel.every((v) => v.o[d].toLowerCase() === 'classic');
      this.root.querySelectorAll('[data-if-classic-only]').forEach((el) => { el.hidden = !onlyClassic; });
      this.root.querySelectorAll('[data-unless-classic-only]').forEach((el) => { el.hidden = onlyClassic; });
    }

    renderVariantText() {
      const block = this.root.querySelector('[data-variant-text]');
      if (!block) return;
      const template = block.querySelector(`[data-variant-text-for="${this.variant.id}"]`);
      block.hidden = !template;
      block.querySelector('[data-variant-text-content]').innerHTML = template ? template.innerHTML : '';
    }

    isEngraved(variant = this.variant) {
      return this.designIndex > -1 && variant.o[this.designIndex].toLowerCase() !== 'classic';
    }

    setupQuantity() {
      const box = this.root.querySelector('[data-qty]');
      if (!box || !this.qtyInput) return;
      const max = Number(this.qtyInput.max) || Infinity;
      const offer = this.root.querySelector('[data-qty-offer]');
      const clamp = () => {
        const value = Math.min(max, Math.max(1, Number.parseInt(this.qtyInput.value, 10) || 1));
        this.qtyInput.value = value;
        box.querySelector('[data-qty-step="-1"]').disabled = value <= 1;
        box.querySelector('[data-qty-step="1"]').disabled = value >= max;
        offer?.setAttribute('aria-pressed', String(value >= 2));
        this.root.dispatchEvent(new CustomEvent('product:quantity', { detail: { quantity: value } }));
      };
      /* Oferta de 2ª unidad: pasa a 2 fundas (o vuelve a 1). */
      offer?.addEventListener('click', () => {
        this.qtyInput.value = Number(this.qtyInput.value) >= 2 ? 1 : 2;
        clamp();
      });
      box.addEventListener('click', (event) => {
        const step = event.target.closest('[data-qty-step]');
        if (!step) return;
        this.qtyInput.value = (Number(this.qtyInput.value) || 1) + Number(step.dataset.qtyStep);
        clamp();
      });
      this.qtyInput.addEventListener('change', clamp);
      clamp();
    }

    /* La app de PayPal pinta «Paga más tarde» en blanco (ajuste de la app, pensado para el tema oscuro actual).
       Lo inserta junto a .buy__paylater; en el panel blanco se pasa a negro y PayPal lo vuelve a pintar. */
    setupPayLater() {
      if (!this.form) return;
      const recolor = () => this.form
        .querySelectorAll(':scope > [data-pp-message]:not([data-pp-style-text-color="monochrome"])')
        .forEach((el) => el.setAttribute('data-pp-style-text-color', 'monochrome'));
      recolor();
      new MutationObserver(recolor).observe(this.form, { childList: true });

      /* El mismo «Paga en 3 plazos», pintado por el tema en .buy__paylater (que solo sale con país ES), con el client-id
         de la app y su cantidad (el precio de la variante), y en monocromo, como se ve hoy. Su SDK no se pide al abrir la
         ficha: al primer toque, scroll o tecla, o cuando el botón de compra queda a media pantalla (Fran, 17/10/2026). Va con
         Messages().render() y sin data-pp-message, para que el SDK de la app, mientras siga activa, no lo pinte también. */
      const slot = this.root.querySelector('[data-paylater][data-paylater-sdk]');
      if (!slot) return;
      const pinta = () => window.CorkPayPal?.Messages({
        amount: this.variant.p / 100,
        placement: 'product',
        style: { layout: 'text', logo: { type: 'none' }, text: { color: 'monochrome', size: 12 } }
      }).render(slot).catch(() => {});
      const gestos = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
      let cerca;
      let pedido = false;
      const carga = () => {
        if (pedido) return;
        pedido = true;
        gestos.forEach((tipo) => window.removeEventListener(tipo, carga, true));
        cerca?.disconnect();
        const sdk = document.createElement('script');
        sdk.src = slot.dataset.paylaterSdk;
        sdk.dataset.namespace = 'CorkPayPal';
        sdk.dataset.partnerAttributionId = slot.dataset.paylaterPartner;
        sdk.addEventListener('load', pinta);
        document.head.append(sdk);
      };
      gestos.forEach((tipo) => window.addEventListener(tipo, carga, { capture: true, passive: true }));
      /* Cerca = el botón de compra, que va justo encima del hueco, a media pantalla. El formulario entero no vale: en
         móvil empieza casi en la primera pantalla y el SDK se pedía al abrir la ficha. */
      cerca = new IntersectionObserver((vistas) => { if (vistas.some((v) => v.isIntersecting)) carga(); }, { rootMargin: '50% 0px' });
      cerca.observe(this.addButton || slot.parentElement);
      this.root.addEventListener('product:variant', pinta);
    }

    /* «Más opciones de pago», el enlace del botón de pago de Shopify, sale con los textos de Shopify, que no tienen
       catalán (ni se pueden traducir en Shopify: no es un texto de la tienda). En catalán llega el aprobado por Fran
       (09/10/2026) en data-more-options y se le pone al enlace cada vez que Shopify lo pinta. */
    setupMoreOptions() {
      const box = this.root.querySelector('[data-dynamic-checkout][data-more-options]');
      if (!box) return;
      const text = box.dataset.moreOptions;
      const fix = () => box.querySelectorAll('.shopify-payment-button__more-options').forEach((link) => {
        if (link.textContent !== text) link.textContent = text;
      });
      fix();
      new MutationObserver(fix).observe(box, { childList: true, subtree: true });
    }

    /* El pago rápido compraría N veces la primera funda, saltaría los cordones obligatorios o dejaría
       fuera el complemento marcado: en esos casos se oculta. */
    updateDynamicCheckout() {
      const box = this.root.querySelector('[data-dynamic-checkout]');
      const units = this.data.multi > 1 && (Number(this.qtyInput?.value) || 1) > 1;
      const addon = Boolean(this.addonTotal && this.addonTotal() > 0);
      if (box) box.hidden = units || this.cordActive || addon;
    }

    /* Configurador del pack «A tu gusto» (cork-cord-picker): solo con su variante, y entonces obligatorio. */
    setupCordPicker() {
      const box = this.root.querySelector('[data-cord-picker]');
      if (!box) return;
      const inputs = [...box.querySelectorAll('[data-cord-input]')];
      const sync = () => {
        const active = String(this.variant.id) === box.dataset.trigger;
        box.hidden = !active;
        inputs.forEach((input) => {
          input.disabled = !active;
          input.required = active;
        });
        this.cordActive = active;
        this.updateDynamicCheckout();
      };
      box.addEventListener('change', (event) => {
        const input = event.target.closest('[data-cord-input]');
        if (!input) return;
        const group = input.closest('[data-cord-group]');
        group.querySelector('[data-cord-selected]').textContent = input.closest('.swatch')?.title || input.value;
        group.querySelector('[data-cord-message]').hidden = true;
      });
      this.root.addEventListener('product:variant', sync);
      this.validators.push(() => {
        if (box.hidden) return true;
        let complete = true;
        box.querySelectorAll('[data-cord-group]').forEach((group) => {
          const chosen = group.querySelector('[data-cord-input]:checked');
          group.querySelector('[data-cord-message]').hidden = Boolean(chosen);
          if (!chosen) complete = false;
        });
        if (!complete) box.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
        return complete;
      });
      sync();
    }

    formProperties() {
      const properties = {};
      new FormData(this.form).forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && value !== '') properties[match[1]] = value;
      });
      return properties;
    }

    /* Líneas a añadir. La selección múltiple (una línea por funda) sustituye esta función. */
    buildItems() {
      const properties = this.formProperties();
      const item = { id: this.variant.id, quantity: Number(this.qtyInput?.value) || 1 };
      if (Object.keys(properties).length) item.properties = properties;
      return [item];
    }

    async onSubmit(event) {
      event.preventDefault();
      if (!this.validators.every((check) => check())) return;
      const button = this.addButton;
      const error = this.root.querySelector('[data-form-error]');
      error.hidden = true;
      button.setAttribute('aria-busy', 'true');
      button.querySelector('[data-add-label]').textContent = button.dataset.labelAdding;
      try {
        await window.CorkCart.add(this.buildItems());
        button.querySelector('[data-add-label]').textContent = button.dataset.labelAdded;
        this.sticky.added();
        setTimeout(() => {
          button.removeAttribute('aria-busy');
          this.renderButton();
        }, 1500);
      } catch (err) {
        button.removeAttribute('aria-busy');
        this.renderButton();
        error.textContent = err.message || button.dataset.labelError;
        error.hidden = false;
      }
    }
  }

  /* Paso 1 «Elige tu móvil»: marcas, buscador, más vendidos y ayuda. Solo interfaz: cambia la
     opción de siempre (radios data-option) y Product hace el resto. */
  class ModelPicker {
    constructor(product) {
      this.root = product.root.querySelector('[data-picker]');
      if (!this.root) return;
      this.product = product;
      this.search = this.root.querySelector('[data-picker-search]');
      this.all = this.root.querySelector('[data-picker-all]');
      this.brand = this.brandOf(product.variant.o[product.modelIndex]);
      this.root.addEventListener('click', (event) => {
        const brand = event.target.closest('[data-picker-brand]');
        if (brand) {
          this.brand = brand.dataset.pickerBrand;
          this.search.value = '';
          this.render();
        }
        const pick = event.target.closest('[data-picker-pick]');
        if (pick) this.choose(pick.dataset.pickerPick);
      });
      this.search.addEventListener('input', () => this.render());
      const extreme = this.root.querySelector('[data-extreme-models]');
      this.extreme = extreme ? JSON.parse(extreme.textContent).models : {};
      this.root.addEventListener('change', (event) => {
        const input = event.target.closest('[data-extreme-model]');
        if (input) product.showExtreme(input.value, this.extreme[input.value]);
      });
      product.root.addEventListener('product:variant', () => this.sync());
      this.setupHelp();
      this.render();
    }

    brandOf(value) {
      return String(value).split(' ')[0];
    }

    choose(value) {
      const radio = [...this.root.querySelectorAll('[data-option]')].find((input) => input.value === value);
      if (!radio || radio.checked) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    sync() {
      const value = this.product.variant.o[this.product.modelIndex];
      this.root.querySelectorAll('[data-picker-pick]').forEach((chip) => chip.setAttribute('aria-pressed', String(chip.dataset.pickerPick === value)));
      this.root.querySelector('[data-picker-current]').textContent = displayValue(value);
    }

    render() {
      const query = searchable(this.search.value);
      this.root.querySelectorAll('[data-picker-brand]').forEach((button) => button.setAttribute('aria-pressed', String(!query && button.dataset.pickerBrand === this.brand)));
      const best = this.root.querySelector('[data-picker-best]');
      if (best) {
        let chips = 0;
        best.querySelectorAll('[data-picker-pick]').forEach((chip) => {
          chip.hidden = Boolean(query) || chip.dataset.brand !== this.brand;
          if (!chip.hidden) chips += 1;
        });
        best.hidden = chips === 0;
      }
      let shown = 0;
      this.root.querySelectorAll('[data-picker-panel]').forEach((panel) => {
        let visible = 0;
        panel.querySelectorAll('.model').forEach((label) => {
          const match = query ? searchable(label.textContent).includes(query) : panel.dataset.pickerPanel === this.brand;
          label.hidden = !match;
          if (match) visible += 1;
        });
        panel.hidden = visible === 0;
        shown += visible;
      });
      if (query) this.all.open = true;
      const empty = this.root.querySelector('[data-picker-empty]');
      if (empty) empty.hidden = !query || shown > 0;
    }

    setupHelp() {
      const dialog = this.root.querySelector('[data-picker-dialog]');
      if (!dialog) return;
      this.root.querySelector('[data-picker-help]').addEventListener('click', () => dialog.showModal());
      dialog.querySelector('[data-picker-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    }
  }

  /* Selección múltiple (cork-multi-variant.js del tema actual): de 2 a N fundas, cada una con su
     modelo y diseño. El precio con descuento sale de Shopify (CorkCart.previewTotal: carrito aparte)
     y la diferencia entre totales es el precio de cada una. Solo se calcula cuando el cliente toca la
     cantidad, la 2ª unidad o una funda (nunca al cargar), con espera de 300 ms entre cambios.
     Al añadir, una línea por funda (cantidad 1) con la propiedad oculta _cork_unit. */
  class Units {
    constructor(product) {
      this.product = product;
      this.box = product.root.querySelector('[data-units]');
      if (!this.box || product.data.multi < 2) return;
      this.ids = [];
      this.previewCache = new Map();
      this.request = 0;
      this.totalKey = '';
      this.totalValue = 0;
      const single = product.buildItems.bind(product);
      product.buildItems = () => (this.quantity() < 2 ? single() : this.items());
      product.unitsTotal = () => this.total();
      this.touched = false;
      product.root.addEventListener('product:quantity', () => {
        this.touched = true;
        this.render();
      });
      product.root.addEventListener('product:variant', () => {
        this.updatePrices();
        this.schedule();
      });
      this.render();
    }

    quantity() {
      return Number(this.product.qtyInput.value) || 1;
    }

    variant(id) {
      return this.product.variants.find((v) => String(v.id) === String(id) && v.a) || null;
    }

    units() {
      const list = [{ unit: 1, variant: this.product.variant }];
      for (let unit = 2; unit <= this.quantity(); unit += 1) {
        const variant = this.variant(this.ids[unit]);
        if (!variant) return [];
        list.push({ unit, variant });
      }
      return list;
    }

    key(units) {
      return units.map(({ variant }) => variant.id).join(':');
    }

    render() {
      const quantity = this.quantity();
      this.box.hidden = quantity < 2;
      this.box.replaceChildren();
      this.product.updateDynamicCheckout();
      if (quantity >= 2) {
        const intro = document.createElement('p');
        intro.className = 'text-small text-secondary';
        intro.textContent = this.box.dataset.intro;
        this.box.append(intro);
        for (let unit = 2; unit <= quantity; unit += 1) {
          if (!this.variant(this.ids[unit])) this.ids[unit] = this.product.variant.id;
          this.box.append(this.buildUnit(unit));
        }
        this.schedule();
      }
      this.product.renderButton();
    }

    buildUnit(unit) {
      const selected = this.variant(this.ids[unit]) || this.product.variant;
      const group = document.createElement('div');
      group.className = 'unit';
      group.setAttribute('role', 'group');
      group.dataset.unit = unit;
      const head = document.createElement('div');
      head.className = 'unit__head';
      const title = document.createElement('span');
      title.className = 'unit__title';
      title.id = `Unit-${this.product.root.dataset.section}-${unit}`;
      title.textContent = `${this.box.dataset.unitLabel} ${unit}`;
      group.setAttribute('aria-labelledby', title.id);
      const price = document.createElement('span');
      price.className = 'unit__price';
      price.dataset.unitPrice = unit;
      this.plainPrice(price, selected);
      head.append(title, price);
      const fields = document.createElement('div');
      fields.className = 'unit__fields';
      this.product.data.options.forEach((name, index) => {
        const label = document.createElement('label');
        label.className = 'field';
        const text = document.createElement('span');
        text.className = 'visually-hidden';
        text.textContent = `${name} · ${title.textContent}`;
        const select = document.createElement('select');
        select.className = 'select';
        /* El diseño, solo entre los que existen para el modelo de esa unidad (hay modelos solo en Classic). */
        const { designIndex: d, modelIndex: m } = this.product;
        const pool = this.product.variants.filter((v) => v.a && (index !== d || v.o[m] === selected.o[m]));
        const values = [...new Set(pool.map((v) => v.o[index]))];
        values.forEach((value) => select.add(new Option(displayValue(value), value, false, selected.o[index] === value)));
        select.addEventListener('change', () => this.change(unit, index, select.value));
        label.append(text, select);
        fields.append(label);
      });
      group.append(head, fields);
      return group;
    }

    change(unit, changed, value) {
      const group = this.box.querySelector(`[data-unit="${unit}"]`);
      const selected = [...group.querySelectorAll('select')].map((select) => select.value);
      selected[changed] = value;
      const available = this.product.variants.filter((v) => v.a);
      let next = available.find((v) => v.o.every((option, i) => option === selected[i]));
      if (!next) {
        const score = (v) => v.o.filter((option, i) => i !== changed && option === selected[i]).length;
        next = available.filter((v) => v.o[changed] === value).sort((a, b) => score(b) - score(a))[0];
      }
      if (next) this.ids[unit] = next.id;
      this.touched = true;
      this.render();
    }

    plainPrice(element, variant) {
      element.removeAttribute('aria-busy');
      element.textContent = variant ? money(variant.p) : this.box.dataset.unavailable;
    }

    discountedPrice(element, original, final) {
      element.removeAttribute('aria-busy');
      if (final >= original) {
        element.textContent = money(final);
        return;
      }
      const was = document.createElement('s');
      was.textContent = money(original);
      const now = document.createElement('strong');
      now.textContent = money(final);
      const label = document.createElement('small');
      label.textContent = this.box.dataset.discountLabel;
      element.replaceChildren(was, now, label);
    }

    updatePrices() {
      this.box.querySelectorAll('[data-unit-price]').forEach((element) => this.plainPrice(element, this.variant(this.ids[Number(element.dataset.unitPrice)])));
      this.product.renderButton();
    }

    schedule() {
      clearTimeout(this.timer);
      clearTimeout(this.fallback);
      const request = ++this.request;
      const units = this.units();
      if (units.length < 2 || !this.touched) return;
      const cached = this.previewCache.get(this.key(units));
      if (cached) return this.apply(cached, request);
      this.box.querySelectorAll('[data-unit-price]').forEach((element) => element.setAttribute('aria-busy', 'true'));
      this.timer = setTimeout(() => {
        if (request !== this.request) return;
        this.preview(units).then((prices) => this.apply(prices, request)).catch(() => {
          if (request === this.request) this.updatePrices();
        });
      }, 300);
      this.fallback = setTimeout(() => {
        if (request !== this.request) return;
        this.request += 1;
        this.updatePrices();
      }, 6000);
    }

    /* Total de estas fundas con los descuentos de Shopify (theme.js: carrito aparte, sin add_to_cart). */
    prefixTotal(units) {
      return window.CorkCart.previewTotal(units.map(({ variant }) => variant.id));
    }

    async preview(units) {
      const key = this.key(units);
      if (this.previewCache.has(key)) return this.previewCache.get(key);
      const totals = [];
      for (let i = 0; i < units.length; i += 1) totals.push(await this.prefixTotal(units.slice(0, i + 1)));
      const prices = { total: totals[totals.length - 1] };
      for (let i = 1; i < units.length; i += 1) {
        prices[units[i].unit] = { original: Number(units[i].variant.p), final: Math.max(0, totals[i] - totals[i - 1]) };
      }
      this.previewCache.set(key, prices);
      return prices;
    }

    apply(prices, request) {
      if (request !== this.request) return;
      clearTimeout(this.fallback);
      this.box.querySelectorAll('[data-unit-price]').forEach((element) => {
        const unit = Number(element.dataset.unitPrice);
        if (prices[unit]) this.discountedPrice(element, prices[unit].original, prices[unit].final);
        else this.plainPrice(element, this.variant(this.ids[unit]));
      });
      this.totalKey = this.key(this.units());
      this.totalValue = prices.total;
      this.product.renderButton();
    }

    /* Total para el botón: con varias fundas, solo el que calcula Shopify. Mientras no lo hay
       (calculando, o si falla o da 429) es null y no se enseña: nunca una suma sin los descuentos. */
    total() {
      const units = this.quantity() < 2 ? [] : this.units();
      if (!units.length) return this.product.variant.p;
      return this.key(units) === this.totalKey ? this.totalValue : null;
    }

    items() {
      const batch = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
      const shared = this.product.formProperties();
      return this.units().map(({ unit, variant }) => ({
        id: variant.id,
        quantity: 1,
        properties: { ...shared, _cork_unit: `${batch}-${unit}` }
      }));
    }
  }

  /* Complemento dentro de la compra (el cordón): casilla, foto, color y precio. Marcado, suma su
     precio al botón y va al carrito como línea aparte (cantidad 1), con las fundas. */
  class Addon {
    constructor(product) {
      this.box = product.root.querySelector('[data-addon]');
      if (!this.box) return;
      this.product = product;
      this.variants = JSON.parse(this.box.querySelector('[data-addon-json]').textContent);
      this.check = this.box.querySelector('[data-addon-check]');
      this.box.addEventListener('change', (event) => {
        if (event.target.matches('[data-addon-variant]')) this.check.checked = true;
        this.render();
      });
      const base = product.buildItems.bind(product);
      product.buildItems = () => base().concat(this.items());
      product.addonTotal = () => (this.active() ? this.current().p : 0);
      this.render();
    }

    current() {
      const picked = this.box.querySelector('[data-addon-variant]:checked');
      return this.variants.find((v) => String(v.id) === (picked ? picked.value : '')) || this.variants[0];
    }

    active() {
      return this.check.checked && Boolean(this.current().a);
    }

    render() {
      const addon = this.current();
      this.box.querySelector('[data-addon-price]').textContent = `+${money(addon.p)}`;
      const option = this.box.querySelector('[data-addon-option]');
      if (option) option.textContent = addon.n;
      const img = this.box.querySelector('[data-addon-img] img');
      if (img && addon.img) {
        img.removeAttribute('srcset');
        img.src = addon.img;
      }
      this.box.classList.toggle('is-on', this.check.checked);
      this.product.renderButton();
      this.product.sticky.render();
      this.product.updateDynamicCheckout();
    }

    items() {
      return this.active() ? [{ id: this.current().id, quantity: 1 }] : [];
    }
  }

  /* Oferta de 2ª unidad (bloque cork_bundle): −5 € y, en la Slim, el diseño de la segunda gratis.
     Solo se enseña el precio; el descuento real lo aplican los descuentos automáticos al pagar. */
  class Bundle {
    constructor(product) {
      this.product = product;
      this.box = product.root.querySelector('[data-bundle]');
      if (!this.box) return;
      const d = this.box.dataset;
      this.m = Number(d.mpos);
      this.d = Number(d.dpos);
      this.hasDesign = d.hasDesign === 'true';
      this.discount = Number(d.discount);
      this.designFree = d.designFree === 'true';
      this.model = this.box.querySelector('[data-bundle-model]');
      this.button = this.box.querySelector('[data-bundle-add]');
      this.userModel = false;
      this.model.addEventListener('change', () => {
        this.userModel = true;
        this.render();
      });
      this.box.addEventListener('change', (event) => {
        if (event.target.matches('[data-bundle-design]')) this.render();
      });
      this.button.addEventListener('click', () => this.add());
      product.root.addEventListener('product:variant', () => this.render());
      this.render();
    }

    find(model, design) {
      return this.product.variants.find((v) => v.o[this.m] === model && (!this.hasDesign || v.o[this.d] === design));
    }

    render() {
      const first = this.product.variant;
      if (!this.userModel) this.model.value = first.o[this.m];
      const design = this.box.querySelector('[data-bundle-design]:checked')?.value;
      const second = this.find(this.model.value, design);
      const q = (selector) => this.box.querySelector(selector);
      q('[data-bundle-single]').textContent = money(first.p);
      this.pair = null;
      if (!second || !second.a || !first.a) {
        q('[data-bundle-price]').textContent = this.box.dataset.unavailable;
        q('[data-bundle-was]').textContent = '';
        q('[data-bundle-save]').textContent = '';
        this.button.disabled = true;
        return;
      }
      let extra = 0;
      if (this.hasDesign && this.designFree) {
        const classic = this.product.variants.find((v) => v.o[this.m] === this.model.value && String(v.o[this.d]).toLowerCase() === 'classic');
        if (classic) extra = Math.max(0, second.p - classic.p);
      }
      const save = this.discount + extra;
      q('[data-bundle-price]').textContent = money(first.p + second.p - save);
      q('[data-bundle-was]').textContent = money(first.p + second.p);
      q('[data-bundle-save]').textContent = this.box.dataset.saveTemplate.replace('{{ amount }}', money(save));
      this.button.disabled = false;
      this.pair = [first, second];
    }

    async add() {
      if (!this.pair) return;
      const [first, second] = this.pair;
      const error = this.box.querySelector('[data-bundle-error]');
      const label = this.button.textContent;
      error.hidden = true;
      this.button.disabled = true;
      this.button.textContent = this.box.dataset.adding;
      try {
        await window.CorkCart.add(first.id === second.id ? [{ id: first.id, quantity: 2 }] : [{ id: first.id, quantity: 1 }, { id: second.id, quantity: 1 }]);
        this.button.textContent = this.box.dataset.added;
      } catch (err) {
        error.textContent = err.message || this.box.dataset.error;
        error.hidden = false;
      }
      setTimeout(() => {
        this.button.textContent = label;
        this.render();
      }, 1500);
    }
  }

  /* Galería por variante. Algoritmo de cork-variant-gallery.js del tema actual:
     el bloque de cada modelo va desde su foto destacada hasta la siguiente; extras por producto
     (videoByFeatured, always, exclude, assign); nunca empieza por un vídeo. */
  class Gallery {
    constructor(root, data) {
      this.root = root.querySelector('[data-gallery]');
      if (!this.root) return;
      this.track = this.root.querySelector('[data-gallery-track]');
      this.thumbs = this.root.querySelector('[data-gallery-thumbs]');
      this.count = this.root.querySelector('[data-gallery-count]');
      this.prev = this.root.querySelector('[data-gallery-prev]');
      this.next = this.root.querySelector('[data-gallery-next]');
      this.alt = data.title;
      const full = (m) => ({ ...m, s: /^(https?:)?\/\//.test(m.s) ? m.s : data.files + m.s, h: m.h || m.w });
      this.media = data.media.map(full);
      this.extras = data.extras.map(full);
      this.cfg = data.gallery || {};
      this.featured = new Set(data.variants.map((v) => String(v.f)).filter((id) => id !== '0'));
      this.groups = this.buildGroups();
      this.list = [];
      this.index = 0;
      this.request = 0;

      this.prev.addEventListener('click', () => this.go(this.index - 1));
      this.next.addEventListener('click', () => this.go(this.index + 1));
      this.track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(this.frame);
        this.frame = window.requestAnimationFrame(() => {
          const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
          if (index !== this.index) this.setIndex(index);
        });
      }, { passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') this.go(this.index + 1);
        if (event.key === 'ArrowLeft') this.go(this.index - 1);
      });
    }

    buildGroups() {
      const groups = {};
      const pending = [];
      let current = null;
      this.media.forEach((m) => {
        const id = String(m.id);
        if (this.featured.has(id)) {
          if (current === null) pending.forEach((p) => { groups[p] = id; });
          current = id;
        }
        if (current === null) pending.push(id);
        else groups[id] = current;
      });
      Object.entries(this.cfg.assign || {}).forEach(([id, target]) => { groups[String(id)] = String(target); });
      return groups;
    }

    listFor(variant) {
      const exclude = (this.cfg.exclude || []).map(String);
      const videoMap = this.cfg.videoByFeatured || {};
      const assign = this.cfg.assign || {};
      const fid = variant && variant.f ? String(variant.f) : '';
      const active = fid && this.groups[fid] ? this.groups[fid] : null;
      let list = this.media.filter((m) => !exclude.includes(String(m.id)) && (active === null || this.groups[String(m.id)] === active));
      const moved = list.filter((m) => assign[String(m.id)] !== undefined);
      list = list.filter((m) => assign[String(m.id)] === undefined).concat(moved);
      if (active !== null) {
        let first = null;
        list = list.filter((m) => {
          if (String(m.id) === fid) { first = m; return false; }
          return true;
        });
        const video = videoMap[fid];
        if (video !== undefined && this.extras[video]) list.unshift(this.extras[video]);
        if (first) list.unshift(first);
      }
      if (list.length > 1 && list[0].t === 'v') {
        const k = list.findIndex((m) => m.t !== 'v');
        if (k > 0) list.unshift(list.splice(k, 1)[0]);
      }
      (this.cfg.always || []).forEach((k) => { if (this.extras[k]) list.push(this.extras[k]); });
      return list;
    }

    src(m, width) {
      return `${m.s}${m.s.includes('?') ? '&' : '?'}width=${width}`;
    }

    image(m, eager) {
      const img = document.createElement('img');
      const widths = [400, 600, 800, 1000, 1200, 1600].filter((w) => w <= m.w);
      img.src = this.src(m, Math.min(1200, m.w));
      if (widths.length) img.srcset = widths.map((w) => `${this.src(m, w)} ${w}w`).join(', ');
      img.sizes = '(min-width: 990px) 56vw, 100vw';
      img.width = m.w;
      img.height = m.h;
      img.alt = m.a || this.alt;
      img.loading = eager ? 'eager' : 'lazy';
      img.decoding = 'async';
      return img;
    }

    slide(m, eager) {
      const li = document.createElement('li');
      li.className = 'gallery__slide';
      li.dataset.mediaId = m.id;
      if (m.t === 'v' && m.v) {
        const video = document.createElement('video');
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = 'none';
        video.poster = this.src(m, 1200);
        /* Primero el HLS, que empieza con la calidad que da la red; si no, el MP4 de 1080p, que en el móvil con
           datos no arrancaba (como snippets/video-fuentes, ff24592). */
        if (m.vh) video.insertAdjacentHTML('beforeend', `<source src="${m.vh}" type="application/x-mpegURL">`);
        video.insertAdjacentHTML('beforeend', `<source src="${m.v}" type="video/mp4">`);
        video.setAttribute('aria-label', m.a || this.alt);
        li.append(video);
        if (reduceMotion.matches) {
          const play = document.createElement('button');
          play.type = 'button';
          play.className = 'gallery__play';
          play.innerHTML = `<span><svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l10.5-6.5z" fill="currentColor" stroke="none"/></svg></span><span class="visually-hidden">${this.root.dataset.playLabel || ''}</span>`;
          play.addEventListener('click', () => { play.remove(); video.controls = true; video.play(); });
          li.append(play);
        }
      } else {
        li.append(this.image(m, eager));
      }
      return li;
    }

    /* Precarga la foto con la que abre (tope 1,5 s) antes de cambiar: la galería nunca se queda vacía.
       startId: abre en esa foto en vez de en la primera (la ficha de los packs, en la de su variante). La
       foto que ya pinta el servidor se queda tal cual y las demás se colocan a sus lados. */
    show(variant, startId) {
      if (!this.root) return;
      const list = this.listFor(variant);
      if (!list.length) return;
      const start = Math.max(0, list.findIndex((m) => String(m.id) === String(startId)));
      const request = ++this.request;
      const firstSlide = this.track.firstElementChild;
      if (!this.list.length && firstSlide && firstSlide.dataset.mediaId === String(list[start].id)) {
        this.render(list, start, firstSlide);
        return;
      }
      const first = list[start].t === 'v' ? null : this.image(list[start], true);
      const swap = () => { if (request === this.request) this.render(list, start); };
      if (!first || first.complete) return swap();
      first.addEventListener('load', swap, { once: true });
      first.addEventListener('error', swap, { once: true });
      setTimeout(swap, 1500);
    }

    render(list, start = 0, keep = null) {
      this.list = list;
      const slides = list.map((m, i) => (i === start && keep ? keep : this.slide(m, i === start)));
      if (keep) {
        /* La foto que pinta el servidor (el LCP) no sale de la página: las demás se ponen a sus lados. Con
           replaceChildren se quitaba y se volvía a poner, y el navegador la volvía a pintar. */
        [...this.track.children].forEach((child) => { if (child !== keep) child.remove(); });
        keep.before(...slides.slice(0, start));
        keep.after(...slides.slice(start + 1));
      } else {
        this.track.replaceChildren(...slides);
      }
      /* Al instante: la pista lleva scroll-behavior smooth y se vería el barrido hasta la foto. */
      this.track.scrollTo({ left: start * this.track.clientWidth, behavior: 'instant' });
      this.thumbs.replaceChildren(
        ...list.map((m, i) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'thumb';
          button.setAttribute('aria-label', `${i + 1} / ${list.length}`);
          const img = document.createElement('img');
          img.src = this.src(m, 160);
          img.alt = '';
          img.loading = 'lazy';
          button.append(img);
          if (m.t === 'v') button.insertAdjacentHTML('beforeend', '<span class="thumb__video"><svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l10.5-6.5z" fill="currentColor" stroke="none"/></svg></span>');
          button.addEventListener('click', () => this.go(i));
          return button;
        })
      );
      const many = list.length > 1;
      this.prev.hidden = !many;
      this.next.hidden = !many;
      this.count.hidden = !many;
      this.setIndex(start);
    }

    /* Salta a una foto por su id (en los packs, al elegir una opción); si no está en la galería, no se mueve. */
    goTo(id) {
      const index = this.list.findIndex((m) => String(m.id) === String(id));
      if (index > -1) this.go(index);
    }

    go(index) {
      const target = Math.max(0, Math.min(this.list.length - 1, index));
      /* Saltos de más de una foto, al instante: un barrido largo solo añade espera. */
      const smooth = !reduceMotion.matches && Math.abs(target - this.index) === 1;
      this.track.scrollTo({ left: target * this.track.clientWidth, behavior: smooth ? 'smooth' : 'instant' });
      this.setIndex(target);
    }

    setIndex(index) {
      this.index = index;
      this.count.textContent = `${index + 1} / ${this.list.length}`;
      this.prev.disabled = index === 0;
      this.next.disabled = index >= this.list.length - 1;
      [...this.thumbs.children].forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
      /* Solo se desplaza la tira: scrollIntoView movería la página y el punto de partida del Tab. */
      const thumb = this.thumbs.children[index]?.getBoundingClientRect();
      const strip = this.thumbs.getBoundingClientRect();
      if (thumb && thumb.left < strip.left) this.thumbs.scrollLeft += thumb.left - strip.left;
      if (thumb && thumb.right > strip.right) this.thumbs.scrollLeft += thumb.right - strip.right;
      [...this.track.children].forEach((slide, i) => {
        const video = slide.querySelector('video');
        if (!video) return;
        if (i === index && !reduceMotion.matches) video.play().catch(() => {});
        else video.pause();
      });
    }
  }

  /* Entrega. España: cuenta atrás hasta las 13:00 (L–V) y fecha estimada (bloque cork_delivery).
     Resto de países: plazos y costes de cork-delivery-geo.js (Sendcloud, 30-09-2026). */
  const GEO_Z1 = [7, 12, '9,99 €', '130 €'];
  const GEO_Z2 = [7, 12, '14,99 €', null];
  const GEO = {
    PT: [2, 5, '5,99 €', '50 €'],
    AD: [1, 2, '16,99 €', '130 €'],
    DE: GEO_Z1, BE: GEO_Z1, DK: GEO_Z1, FR: GEO_Z1, IE: GEO_Z1, IT: GEO_Z1, NL: GEO_Z1, PL: GEO_Z1, SE: GEO_Z1,
    HR: GEO_Z2, FI: GEO_Z2, GR: GEO_Z2
  };
  const GEO_TEXT = {
    es: { today: 'Pídelo antes de las 13:00 y sale hoy. Llegada estimada: <b>{r}</b>', next: 'Llegada estimada: <b>{r}</b>', eng: 'Diseño grabado bajo pedido. Llegada estimada: <b>{r}</b>', ship: 'Envío {c}', free: ' · gratis desde {f}', tail: '. Plazo en días laborables, orientativo.', engTail: '. Cada diseño se graba a láser para ti.' },
    ca: { today: 'Demana-la abans de les 13:00 i surt avui. Arribada estimada: <b>{r}</b>', next: 'Arribada estimada: <b>{r}</b>', eng: 'Disseny gravat per encàrrec. Arribada estimada: <b>{r}</b>', ship: 'Enviament {c}', free: ' · gratis des de {f}', tail: '. Termini en dies laborables, orientatiu.', engTail: '. Cada disseny es grava amb làser per a tu.' },
    en: { today: 'Order before 13:00 and it ships today. Estimated arrival: <b>{r}</b>', next: 'Estimated arrival: <b>{r}</b>', eng: 'Engraved design made to order. Estimated arrival: <b>{r}</b>', ship: 'Shipping {c}', free: ' · free from {f}', tail: '. Working days, estimated.', engTail: '. Every design is laser-engraved for you.' },
    fr: { today: 'Commande avant 13h00, expédition aujourd’hui. Arrivée estimée : <b>{r}</b>', next: 'Arrivée estimée : <b>{r}</b>', eng: 'Design gravé sur commande. Arrivée estimée : <b>{r}</b>', ship: 'Livraison {c}', free: ' · offerte dès {f}', tail: '. Jours ouvrables, délai indicatif.', engTail: '. Chaque design est gravé au laser pour toi.' },
    de: { today: 'Bis 13:00 Uhr bestellen, Versand noch heute. Voraussichtliche Ankunft: <b>{r}</b>', next: 'Voraussichtliche Ankunft: <b>{r}</b>', eng: 'Gravur auf Bestellung. Voraussichtliche Ankunft: <b>{r}</b>', ship: 'Versand {c}', free: ' · gratis ab {f}', tail: '. Werktage, unverbindlich.', engTail: '. Jedes Design wird für dich lasergraviert.' },
    it: { today: 'Ordina entro le 13:00 e parte oggi. Arrivo stimato: <b>{r}</b>', next: 'Arrivo stimato: <b>{r}</b>', eng: 'Design inciso su ordinazione. Arrivo stimato: <b>{r}</b>', ship: 'Spedizione {c}', free: ' · gratis da {f}', tail: '. Giorni lavorativi, tempi indicativi.', engTail: '. Ogni design viene inciso al laser per te.' },
    pt: { today: 'Encomenda antes das 13:00 e sai hoje. Chegada estimada: <b>{r}</b>', next: 'Chegada estimada: <b>{r}</b>', eng: 'Design gravado por encomenda. Chegada estimada: <b>{r}</b>', ship: 'Envio {c}', free: ' · grátis a partir de {f}', tail: '. Dias úteis, prazo indicativo.', engTail: '. Cada design é gravado a laser para ti.' }
  };
  const DAY = 864e5;
  /* Festivos nacionales en España: ese día ni sale ni se entrega nada (los autonómicos no cuentan). El 12/10/2026
     cae en lunes y la ficha prometía la entrega ese día.
     ponytail: lista fija hasta 2027 (el Viernes Santo cambia cada año); añadir 2028 antes de que acabe 2027. */
  const HOLIDAYS = new Set([
    '2026-01-01', '2026-01-06', '2026-04-03', '2026-05-01', '2026-08-15', '2026-10-12', '2026-11-01', '2026-12-06', '2026-12-08', '2026-12-25',
    '2027-01-01', '2027-01-06', '2027-03-26', '2027-05-01', '2027-08-15', '2027-10-12', '2027-11-01', '2027-12-06', '2027-12-08', '2027-12-25',
  ]);
  const isWorkday = (ts) => {
    const w = new Date(ts).getUTCDay();
    return w >= 1 && w <= 5 && !HOLIDAYS.has(new Date(ts).toISOString().slice(0, 10));
  };
  const ENGRAVE_MIN = 1;
  const ENGRAVE_MAX = 4;

  class Delivery {
    constructor(box, product) {
      this.box = box;
      this.product = product;
      if (!box) return;
      this.main = box.querySelector('[data-delivery-main]');
      this.sub = box.querySelector('[data-delivery-sub]');
      this.dot = box.querySelector('[data-delivery-dot]');
      this.text = JSON.parse(box.querySelector('[data-delivery-text]').textContent);
      this.country = (box.dataset.country || 'ES').toUpperCase();
      const [h, m] = (box.dataset.cutoff || '13:00').split(':');
      this.cutoff = Number(h) * 60 + Number(m || 0);
      setInterval(() => this.render(), 30000);
    }

    now() {
      try {
        const parts = {};
        new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/Madrid', hour: '2-digit', minute: '2-digit', hour12: false,
          weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric'
        }).formatToParts(new Date()).forEach((p) => { if (p.type !== 'literal') parts[p.type] = p.value; });
        return {
          min: (Number(parts.hour) % 24) * 60 + Number(parts.minute),
          base: Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)),
          wd: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(parts.weekday)
        };
      } catch (e) {
        const d = new Date();
        return { min: d.getHours() * 60 + d.getMinutes(), base: Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()), wd: d.getDay() };
      }
    }

    setSub(text) {
      if (this.sub) this.sub.textContent = text;
    }

    render() {
      if (!this.box) return;
      /* Un pack puede traer su propia nota (el Dream Team cuenta desde que llega el logo). */
      const note = this.product.deliveryNote?.();
      if (note) {
        this.dot.className = 'dot dot--wait';
        this.main.textContent = note.main;
        this.setSub(note.sub || '');
        return;
      }
      const engraved = this.product.isEngraved();
      this.dot.className = `dot ${engraved ? 'dot--wait' : 'dot--ok'}`;
      if (this.country === 'ES') this.renderSpain(engraved);
      else this.renderGeo(engraved);
    }

    renderSpain(engraved) {
      const t = this.text;
      if (engraved) {
        this.main.innerHTML = t.engravedMain;
        /* Un pack sale entero cuando está grabado: debajo, el envío solo, sin «el acabado Classic sale en 24 h». */
        this.setSub(this.product.spec && t.ship ? t.ship : t.engravedSub);
        return;
      }
      const n = this.now();
      const nextWeekday = (ts) => { let d = ts + DAY; while (!isWorkday(d)) d += DAY; return d; };
      const shipToday = isWorkday(n.base) && n.min < this.cutoff;
      const shipTs = shipToday ? n.base : nextWeekday(n.base);
      const deliverTs = nextWeekday(shipTs);
      const days = t.weekdays.split(',');
      const months = t.months.split(',');
      const d = new Date(deliverTs);
      const label = t.dateLabel.replace('{{ weekday }}', days[d.getUTCDay()]).replace('{{ day }}', d.getUTCDate()).replace('{{ month }}', months[d.getUTCMonth()]);
      const date = (deliverTs - n.base === DAY ? t.dateTomorrow : t.dateOn).replace('{{ date }}', label);
      if (shipToday) {
        const left = this.cutoff - n.min;
        const h = Math.floor(left / 60);
        const m = left % 60;
        const time = h > 0 ? t.leftHours.replace('{{ h }}', h).replace('{{ m }}', m) : m === 1 ? t.leftMinute : t.leftMinutes.replace('{{ m }}', m);
        this.main.innerHTML = t.todayMain.replace('{{ time }}', time).replace('{{ date }}', date);
        this.setSub(t.todaySub);
      } else {
        this.main.innerHTML = t.nextMain.replace('{{ date }}', date);
        this.setSub(t.nextSub);
      }
    }

    renderGeo(engraved) {
      const cfg = GEO[this.country];
      if (!cfg) {
        this.main.closest('li').hidden = true;
        return;
      }
      const lang = (document.documentElement.lang || 'es').toLowerCase();
      const L = GEO_TEXT[lang.slice(0, 2)] || GEO_TEXT.es;
      const isBiz = isWorkday;
      const addBiz = (ts, count) => { let d = ts; let left = count; while (left > 0) { d += DAY; if (isBiz(d)) left -= 1; } return d; };
      const nextBiz = (ts) => { let d = ts + DAY; while (!isBiz(d)) d += DAY; return d; };
      const fmt = (ts) => {
        try { return new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }).format(new Date(ts)); } catch (e) { return new Date(ts).toISOString().slice(0, 10); }
      };
      const n = this.now();
      const shipToday = isWorkday(n.base) && n.min < this.cutoff;
      let shipTs = shipToday ? n.base : nextBiz(n.base);
      let maxDays = cfg[1];
      if (engraved) {
        shipTs = addBiz(shipTs, ENGRAVE_MIN);
        maxDays = cfg[1] + (ENGRAVE_MAX - ENGRAVE_MIN);
      }
      const from = addBiz(shipTs, cfg[0]);
      const to = addBiz(shipTs, maxDays);
      const range = from === to ? fmt(from) : `${fmt(from)} – ${fmt(to)}`;
      const template = engraved ? L.eng : shipToday ? L.today : L.next;
      const ship = L.ship.replace('{c}', cfg[2]) + (cfg[3] ? L.free.replace('{f}', cfg[3]) : '');
      this.main.innerHTML = template.replace('{r}', range);
      this.setSub(ship + (engraved ? L.engTail : L.tail));
    }
  }

  /* Barra fija: nombre, precio, anclas y botón. Aparece cuando el botón principal sale de pantalla;
     en móvil, además, solo después de pasar el precio (la primera pantalla queda despejada).
     Si todavía no se ha elegido móvil, su botón lleva al paso 1 en vez de comprar el de por defecto. */
  class StickyBuy {
    constructor(root, product) {
      this.bar = root.querySelector('[data-sticky-buy]');
      this.product = product;
      if (!this.bar || !product.addButton) return;
      this.name = this.bar.querySelector('[data-sticky-name]');
      this.price = this.bar.querySelector('[data-sticky-price]');
      this.button = this.bar.querySelector('[data-sticky-add]');
      this.picker = root.querySelector('[data-picker]');
      this.chosen = !this.picker || new URLSearchParams(window.location.search).has('variant');
      document.body.append(this.bar);
      this.bar.querySelectorAll('[data-sticky-anchor]').forEach((link) => {
        const target = document.querySelector(`[id^="${link.dataset.stickyAnchor}-"]`);
        if (target) link.href = `#${target.id}`;
        else link.hidden = true;
      });
      this.button.addEventListener('click', () => {
        if (this.chosen) product.form.requestSubmit();
        else this.picker.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      });
      root.addEventListener('product:variant', () => {
        this.chosen = true;
        this.render();
      });
      const wide = window.matchMedia('(min-width: 990px)');
      const priceBox = root.querySelector('[data-price]');
      const update = () => {
        const rect = product.addButton.getBoundingClientRect();
        const inView = rect.bottom > 0 && rect.top < window.innerHeight;
        const past = wide.matches ? rect.top < 0 : !priceBox || priceBox.getBoundingClientRect().bottom < 0;
        /* Con el botón «Extreme» en lugar de la compra, la barra no sale: añadiría la Slim de otro modelo. */
        const visible = !inView && past && !('extreme' in root.dataset);
        this.bar.classList.toggle('is-visible', visible);
        this.bar.inert = !visible;
      };
      let frame;
      window.addEventListener('scroll', () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', update);
      this.update = update;
      update();
      this.render();
    }

    name_() {
      const { data, variant } = this.product;
      if (data.variants.length === 1 && variant.o[0] === 'Default Title') return data.title;
      /* Sin móvil elegido, el nombre de la funda («Cork Slim»): la variante por defecto nombraba un modelo que
         nadie ha elegido mientras el botón pide «Elige tu móvil». */
      if (!this.chosen) return data.title.split(' · ').pop();
      let name = variant.o.join(' · ');
      if (data.sticky) {
        name = data.sticky;
        variant.o.forEach((value, i) => { name = name.replace(`{${i + 1}}`, value); });
        name = name.replace(/\{\d\}/g, '').replace(/\s{2,}/g, ' ').trim();
      }
      return displayValue(name);
    }

    render() {
      if (!this.bar) return;
      const v = this.product.variant;
      this.name.textContent = this.name_();
      const total = this.product.total();
      this.price.textContent = total === null ? '' : money(total);
      if (this.button.dataset.busy !== 'true') this.button.textContent = this.chosen ? this.button.dataset.labelAdd : this.button.dataset.labelChoose;
      this.button.disabled = this.chosen && !v.a;
    }

    added() {
      if (!this.bar) return;
      this.button.dataset.busy = 'true';
      this.button.textContent = this.button.dataset.added;
      setTimeout(() => {
        this.button.dataset.busy = 'false';
        this.render();
      }, 2500);
    }
  }

  /* «¿Cuál es para ti?»: peso y medidas de cada funda para el modelo elegido en la ficha, con una
     barra por dato relativa entre las dos, y el enlace a la otra funda con ese mismo modelo. */
  class Comparator {
    constructor(root) {
      this.root = root;
      this.data = JSON.parse(root.querySelector('[data-cmp-json]').textContent);
      const model = (product, variant) => variant.o[product ? product.modelIndex : 0];
      document.addEventListener('product:variant', (event) => this.render(model(event.target.product, event.detail.variant)));
      const product = document.querySelector('[data-product]')?.product;
      if (product) this.render(model(product, product.variant));
    }

    rows(text) {
      return String(text || '').split('\n').map((line) => {
        const at = line.indexOf(':');
        return at > 0 && line.slice(at + 1).trim() ? [line.slice(0, at).trim(), line.slice(at + 1).trim()] : null;
      }).filter(Boolean);
    }

    number(value) {
      return Number.parseFloat(String(value).replace(',', '.')) || 0;
    }

    render(model) {
      const cards = [...this.root.querySelectorAll('[data-cmp-card]')].map((card) => {
        const product = this.data[card.dataset.cmpCard] || { models: {} };
        const match = model ? product.models[model] : null;
        return { card, product, match, rows: match ? this.rows(match.t) : null };
      });
      const max = {};
      cards.forEach(({ rows }) => (rows || []).forEach(([label, value]) => { max[label] = Math.max(max[label] || 0, this.number(value)); }));
      cards.forEach(({ card, product, match, rows }) => {
        const stats = card.querySelector('[data-cmp-stats]');
        if (rows) {
          stats.replaceChildren(...rows.map(([label, value]) => {
            const row = document.createElement('div');
            row.className = 'cmp-stat';
            const dt = document.createElement('dt');
            dt.textContent = label;
            const dd = document.createElement('dd');
            dd.className = 'tabular';
            dd.textContent = value;
            const meter = document.createElement('span');
            meter.className = 'cmp-meter';
            meter.setAttribute('aria-hidden', 'true');
            meter.innerHTML = '<span></span>';
            meter.firstChild.style.setProperty('--v', max[label] ? (this.number(value) / max[label]).toFixed(3) : 0);
            row.append(dt, dd, meter);
            return row;
          }));
        }
        stats.hidden = !rows;
        const link = card.querySelector('[data-cmp-link]');
        if (link) link.href = match ? `${product.url}?variant=${match.id}` : product.url;
      });
    }
  }

  /* La ficha de los packs (pack.js) reutiliza el paso «Elige tu móvil», la entrega estimada y la galería tal cual. */
  window.CorkPicker = ModelPicker;
  window.CorkDelivery = Delivery;
  window.CorkGallery = Gallery;

  document.querySelectorAll('[data-product]').forEach((root) => new Product(root));
  document.querySelectorAll('[data-cmp]').forEach((root) => new Comparator(root));
})();
